var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2778 41.3888V38.6113H56.6666V41.3888H50.2778ZM52.3333 53.3333L47.1945 49.5L48.8612 47.2779L53.9999 51.1113L52.3333 53.3333ZM48.9445 32.6946L47.2778 30.4721L52.3333 26.6667L53.9999 28.8888L48.9445 32.6946ZM28.6112 51.6667V45H26.1112C25.3473 45 24.6933 44.7281 24.1491 44.1842C23.6052 43.64 23.3333 42.986 23.3333 42.2221V37.7779C23.3333 37.014 23.6052 36.36 24.1491 35.8158C24.6933 35.272 25.3473 35 26.1112 35H33.3333L41.6666 30V50L33.3333 45H31.3887V51.6667H28.6112ZM38.8887 45.0833V34.9167L34.0833 37.7779H26.1112V42.2221H34.0833L38.8887 45.0833ZM43.3333 45.5833V34.4167C44.0833 35.0833 44.6874 35.8958 45.1458 36.8542C45.6041 37.8125 45.8333 38.8611 45.8333 40C45.8333 41.1389 45.6041 42.1875 45.1458 43.1458C44.6874 44.1042 44.0833 44.9167 43.3333 45.5833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowCampaigns);
export default __webpack_public_path__ + "static/media/icon-flow-campaigns.75cfbb20390fe672b66892aa88b7b376.svg";
export { ForwardRef as ReactComponent };